import logo from '../assets/logo.svg';

interface MaintenanceProps {
    logoSrc?: string;
    logoAlt?: string;
}

export function Maintenance({ logoSrc = logo, logoAlt = 'APRIL Moto' }: MaintenanceProps = {}) {
    const handleRetry = () => {
        window.location.href = '/';
    };

    return (
        <main className="min-h-screen flex items-center justify-center bg-white px-4 py-12">
            <div className="w-full max-w-xl text-center">
                <img
                    alt={logoAlt}
                    className="mx-auto h-auto w-32 sm:w-40 mb-8"
                    src={logoSrc}
                />
                <h1 className="text-2xl sm:text-3xl font-semibold text-gray-900 mb-6">
                    Notre formulaire est momentanément indisponible
                </h1>
                <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-3">
                    Notre formulaire de souscription est momentanément à l’arrêt le temps d’une révision.
                </p>
                <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-8">
                    La souscription en ligne sera de nouveau accessible très prochainement.
                </p>
                <button
                    type="button"
                    onClick={handleRetry}
                    className="inline-flex items-center justify-center rounded-full bg-primary px-6 py-3 text-base font-medium text-white shadow-sm transition-colors hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 cursor-pointer"
                >
                    Je réessaie
                </button>
            </div>
        </main>
    );
}
